module.exports = __webpack_public_path__ + "static/media/vail-19.6ed701a9.jpg";